/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContentManagerSingleDocumentViewModel } from './ContentManagerSingleDocumentViewModel';
import {
    ContentManagerSingleDocumentViewModelFromJSON,
    ContentManagerSingleDocumentViewModelFromJSONTyped,
    ContentManagerSingleDocumentViewModelToJSON,
} from './ContentManagerSingleDocumentViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfContentManagerSingleDocumentViewModel
 */
export interface ResultOfContentManagerSingleDocumentViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfContentManagerSingleDocumentViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfContentManagerSingleDocumentViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfContentManagerSingleDocumentViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfContentManagerSingleDocumentViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfContentManagerSingleDocumentViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfContentManagerSingleDocumentViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfContentManagerSingleDocumentViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ContentManagerSingleDocumentViewModel}
     * @memberof ResultOfContentManagerSingleDocumentViewModel
     */
    data?: ContentManagerSingleDocumentViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfContentManagerSingleDocumentViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfContentManagerSingleDocumentViewModel interface.
 */
export function instanceOfResultOfContentManagerSingleDocumentViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfContentManagerSingleDocumentViewModelFromJSON(json: any): ResultOfContentManagerSingleDocumentViewModel {
    return ResultOfContentManagerSingleDocumentViewModelFromJSONTyped(json, false);
}

export function ResultOfContentManagerSingleDocumentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfContentManagerSingleDocumentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ContentManagerSingleDocumentViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfContentManagerSingleDocumentViewModelToJSON(value?: ResultOfContentManagerSingleDocumentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ContentManagerSingleDocumentViewModelToJSON(value.data),
        'Count': value.count,
    };
}

